import { ref, onMounted } from 'vue'

const overflowScrollReg = /scroll|auto|overlay/i
const defaultRoot = window

function isElement (node) {
  const ELEMENT_NODE_TYPE = 1
  return (
    node.tagName !== 'HTML' &&
    node.tagName !== 'BODY' &&
    node.nodeType === ELEMENT_NODE_TYPE
  )
}

// https://github.com/vant-ui/vant/issues/3823
export function getScrollParent (
  el,
  root = defaultRoot
) {
  let node = el

  while (node && node !== root && isElement(node)) {
    const { overflowY } = window.getComputedStyle(node)
    if (overflowScrollReg.test(overflowY)) {
      return node
    }
    node = node.parentNode
  }

  return root
}

export function useScrollParent (
  el,
  root = defaultRoot
) {
  const scrollParent = ref()

  onMounted(() => {
    if (el.value) {
      scrollParent.value = getScrollParent(el.value, root)
    }
  })

  return scrollParent
}
